/* eslint-disable no-restricted-syntax */
/* eslint-disable no-alert */
/* eslint-disable no-restricted-globals */
// #region import
import React, { useEffect, useState } from 'react';
import GetMunicipality from '../../../api/MunicipalityAPI';
import { City, addMunicipalityCode } from '../../../models/municipality';
import { target } from '../../../models/notificationHistoryInfo';
import { SendRequestDto } from '../../../api/PushSendAPI';
import {
  PostDeleteLog,
  SendRequestDto as SendDeleteRequestDto,
} from '../../../api/DeleteLogAPI';
import {
  ERROR_MESSAGE_API,
  TITLE_TEXT,
  MESSAGE_TEXT,
  AUTHOR_TEXT,
  PARAMETER_TEXT,
  URL_TEXT,
  LOCATION_ALL_SELECTED_TEXT,
  CURRENT_LOCATION_TEXT,
  NOTIFICATION_TYPE_TEXT,
  PUSH_LOG_DETAIL_TEXT,
  SEND_STATUS_TEXT,
  SEND_DATETIME_TEXT,
  SEND_SUCCEED_TEXT,
  SEND_FAILED_TEXT,
  BACK_TO_INDEX_TEXT,
  DELETE_LOG_TEXT,
  REUSE_LOG_TEXT,
  DEVICE_TYPE_ANDROID_CODE,
  DEVICE_TYPE_IOS_CODE,
} from '../../../util/Const';
import { GetType, GetTimestamp, SendStatus } from '../GenericMethod';
// #endregion import

const NotificationHistoryDetail = (props: any) => {
  const { history, selectedHistory, setSelectedHistory } = props;

  // 市区町村リスト
  const [cityList, setCityList] = useState<City[]>([]);
  useEffect(() => {
    GetMunicipality()
      .then((response: any) => {
        const cityItems: City[] = [];
        for (const prefecture of response) {
          for (const city of prefecture.cities) {
            cityItems.push(city);
          }
        }
        setCityList(cityItems);
      })
      .catch(() => {
        alert(ERROR_MESSAGE_API);
      });
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!history) {
    return null;
  }

  const handleClickCloseBtn = () => {
    setSelectedHistory(null);
  };

  const handleClickReuseBtn = () => {
    const request: SendRequestDto = {
      title: selectedHistory.title,
      message: selectedHistory.message,
      author: sessionStorage.getItem('name'),
      device: [DEVICE_TYPE_ANDROID_CODE, DEVICE_TYPE_IOS_CODE],
      target: addMunicipalityCode(selectedHistory.target),
      url: selectedHistory.url,
      type: selectedHistory.type,
      is_debug: selectedHistory.isDebug,
    };
    history.push({ pathname: '/PushSend', state: request });
  };

  const handleClickDeleteBtn = async () => {
    try {
      const result = confirm('表示されている履歴を削除します。');
      if (result) {
        const dto: SendDeleteRequestDto = {
          id: selectedHistory.id,
        };
        await PostDeleteLog(dto)
          .then(() => {
            setSelectedHistory(null);
          })
          .catch(() => {
            alert(ERROR_MESSAGE_API);
          });
      }
    } catch (error) {
      alert(ERROR_MESSAGE_API);
    }
  };

  const handleClickUrlBtn = (url: string) => {
    window.open(url);
  };

  // #region 対象地域
  let targetList: string = '';
  if (selectedHistory.target.length > 0) {
    const list: string[] = [];
    selectedHistory.target.forEach((item: target) => {
      const city = cityList.find((v) => v.city_code === item.city_code);
      let name = '';
      if (city) {
        name = city.city_name;
        if (item.village_code) {
          const village = city?.villages.find(
            (v) => v.village_code === item.village_code
          );
          if (village) {
            name += village.village_name;
          }
        }
      }
      list.push(name);
    });
    targetList = list.join('/');
  } else {
    targetList = LOCATION_ALL_SELECTED_TEXT;
  }
  // #endregion 対象地域

  return (
    <article id="history_detail" className="rireki">
      <h1>{PUSH_LOG_DETAIL_TEXT}</h1>
      <div className="busadd_btnarea">
        <button
          type="button"
          className="btn_back"
          onClick={() => handleClickDeleteBtn()}
        >
          {DELETE_LOG_TEXT}
        </button>
        <button
          type="button"
          className="btn_back"
          onClick={() => handleClickReuseBtn()}
        >
          {REUSE_LOG_TEXT}
        </button>
        <button
          type="button"
          className="btn_back"
          onClick={() => handleClickCloseBtn()}
        >
          {BACK_TO_INDEX_TEXT}
        </button>
      </div>
      <div className="margin-top detail">
        <div>
          <dl className="box">
            <dd className="location">{TITLE_TEXT}</dd>
            <dd>{selectedHistory.title}</dd>
          </dl>
        </div>
        <div>
          <dl className="box">
            <dd className="location">{MESSAGE_TEXT}</dd>
            <dd>{selectedHistory.message}</dd>
          </dl>
        </div>
        <div>
          <dl className="box">
            <dd className="location">{SEND_STATUS_TEXT}</dd>
            <dd>{SendStatus(selectedHistory.status)}</dd>
          </dl>
        </div>
        {selectedHistory.timestamp ? (
          <div>
            <dl className="box">
              <dd className="location">{SEND_DATETIME_TEXT}</dd>
              <dd>{GetTimestamp(selectedHistory.timestamp)}</dd>
            </dl>
          </div>
        ) : null}
        {selectedHistory.status !== 0 ? (
          <>
            <div>
              <dl className="box">
                <dd className="location">{SEND_SUCCEED_TEXT}</dd>
                <dd>{selectedHistory.succeedDevices}件</dd>
              </dl>
            </div>
            <div>
              <dl className="box">
                <dd className="location">{SEND_FAILED_TEXT}</dd>
                <dd>{selectedHistory.failedDevices}件</dd>
              </dl>
            </div>
          </>
        ) : null}
        <div>
          <dl className="box">
            <dd className="location">{PARAMETER_TEXT}</dd>
            <div className="margin">
              {selectedHistory.type !== '' ? (
                <div className="margin">
                  <span className="bold">{NOTIFICATION_TYPE_TEXT}:</span>
                  <span>{GetType(selectedHistory.type)}</span>
                </div>
              ) : null}
              {selectedHistory.author != null ? (
                <div className="margin">
                  <span className="bold">{AUTHOR_TEXT}:</span>
                  <span>{selectedHistory.author}</span>
                </div>
              ) : null}
              {selectedHistory.target != null ? (
                <div className="margin">
                  <span className="bold">{CURRENT_LOCATION_TEXT}:</span>
                  <span>{targetList}</span>
                </div>
              ) : null}
              {selectedHistory.url != null ? (
                <div className="margin">
                  <span className="bold">{URL_TEXT}:</span>
                  <button
                    type="button"
                    className="btn_detail_url"
                    onClick={() => handleClickUrlBtn(selectedHistory.url)}
                  >
                    {selectedHistory.url}
                  </button>
                </div>
              ) : null}
            </div>
          </dl>
        </div>
      </div>
    </article>
  );
};
export default NotificationHistoryDetail;
